var cilExpandUp = ["512 512", "<rect width='480' height='32' x='16' y='467' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M16,147H496V19H16ZM48,51H464v64H48Z' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M256.077,211.777,96,379.079V419H416V381.14ZM132.709,387,255.923,258.224,377.522,387Z' class='ci-primary'/>"];

export { cilExpandUp };

